import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import IllegalConstructionSidebar from "../IllegalConstructionSidebar/IllegalConstructionSidebar";
import { HeaderIllegal } from "../HeaderIllegal";
import { ZoneNameCommanDDL } from "../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import Select from "react-select/base";
import Map from "./Modal/Map";
export const VehicleTrackingIllegalGrid = () => {

    const { t } = useTranslation()
    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };


    const [DashType, setDashType] = useState(localStorage.getItem('DashType') ? localStorage.getItem('DashType') : 1)

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])


    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const DataObj = ({
        isCountLoading: '',
        Language: Language.Label
    })

    const [DesignationNameID, setDesignationNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [VehicleID, setVehicleID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const optionsVehicle = [
        { id: 1, value: 'Bike', label: 'Bike' },
        { id: 2, value: 'Car', label: 'Car' },
    ]
    const [MapPopUpShow, setMapPopUpShow] = useState(false)

    const handleMap = () => {
        setMapPopUpShow(!MapPopUpShow)
    }

    return (
        <>
            <HeaderIllegal />
            <div className="wrapper bg-change">

                <IllegalConstructionSidebar />

                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/*Vehicle Tracking */}
                            <h5 className="text-dark fw-bold ps-3  pt-3 all_heading_fontsize">
                                {t('EncroachmentDashboard.VehicleTracking')}
                                {/* Vehicle Tracking */}
                            </h5>
                        </div>
                    </div>

                    <div className="row ps-3 eic_table_styles py-2" >



                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost=''
                                Language={Language}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.VehicleName')}</label><br />
                            <Select
                                id='DDLID'
                                isClearable={false}
                                // isRtl={isRtl}
                                isSearchable
                                maxMenuHeight={130}
                                value={{ value: VehicleID.ID, label: VehicleID.Label }}
                                onChange={(e) => {
                                    e ?
                                        setVehicleID({ ...VehicleID, ID: e.value, Label: e.label })
                                        :
                                        setVehicleID({ ...VehicleID, ID: 0, Label: "Select..." })

                                }}
                                options={optionsVehicle}
                            />
                        </div>

                        <div className="col-12 col-lg-3 col-md-4 mt-3">

                            <button type="button" className="btn btn-success mx-3 mt-4">Search</button>
                            <button type="button" className="btn btn-danger mt-4">Clear</button>
                        </div>


                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.date')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Shift')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ShiftTiming')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleModule')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.VehicleNumber')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Track')}</th>

                                            </tr>

                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td className="py-1" align="center">1</td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center">
                                                    <button className="Track_button"
                                                        onClick={() => handleMap()}
                                                    >
                                                        {/* {t('EncroachmentDashboard.Track')} */}
                                                        <i class="fa-solid fa-location-dot"></i>
                                                    </button>
                                                </td>




                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>


                        </div>
                    </div>

                </div>
            </div>

            {
                MapPopUpShow ?
                    <Map
                        message="Add"
                        handleMap={handleMap}
                    // heading="Forward"
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }
        </>
    )
}

